export default __webpack_public_path__ + "static/media/serve1.38408cd8.png";